import { Brand } from '../brand';
import { useEffect } from 'react';

export const Splash = () => {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    if (window.Loader) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      window.Loader.postMessage('true');
    }

    return () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      if (window.Loader) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.Loader.postMessage('false');
      }
    };
  }, []);
  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div className="w-28 -mt-14">
        <Brand />
      </div>
    </div>
  );
};
